import { render } from "./QuizOneToMany.vue?vue&type=template&id=72d3c7b4&scoped=true"
import script from "./QuizOneToMany.vue?vue&type=script&lang=js"
export * from "./QuizOneToMany.vue?vue&type=script&lang=js"

import "./QuizOneToMany.vue?vue&type=style&index=0&id=72d3c7b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d3c7b4"]])

export default __exports__